import { render } from "./index.vue?vue&type=template&id=e618e0c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e618e0c2&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=e618e0c2&lang=less"
script.render = render
script.__scopeId = "data-v-e618e0c2"

export default script